import { render } from "./manage.vue?vue&type=template&id=2db91cf9&scoped=true&ts=true"
import script from "./manage.vue?vue&type=script&lang=tsx"
export * from "./manage.vue?vue&type=script&lang=tsx"

import "./manage.vue?vue&type=style&index=0&id=2db91cf9&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2db91cf9"]])

export default __exports__